"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
var IsComplicationsBeforeText_1 = __importDefault(require("./IsComplicationsBeforeText"));
;
;
var IsComplicationsBeforeOption = /** @class */ (function (_super) {
    __extends(IsComplicationsBeforeOption, _super);
    function IsComplicationsBeforeOption(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            value: state.data.is_complications_before_option,
            error: state.error.is_complications_before_option
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            if (_this._isMounted) {
                var state_1 = form_store_1.default.getState();
                _this.setState({
                    value: state_1.data.is_complications_before_option,
                    error: state_1.error.is_complications_before_option
                });
            }
        });
        return _this;
    }
    IsComplicationsBeforeOption.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    IsComplicationsBeforeOption.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    IsComplicationsBeforeOption.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error, errorElem = (react_1.default.createElement("div", null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        var labels = [
            "早産",
            "妊娠高血圧症候群（HELLP症候群、子癇を含む）",
            "妊娠糖尿病",
            "胎児発育不全",
            "前置胎盤・低置胎盤",
            "癒着胎盤",
            "常位胎盤早期剥離",
            "その他",
        ];
        var form_elems = labels.map(function (label, key) { return (react_1.default.createElement("div", { key: key },
            react_1.default.createElement("li", { className: "input-list__item" },
                react_1.default.createElement("label", { className: "input-checkbox" },
                    react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: "is_complications_before_option", value: "".concat(key + 1), checked: value.indexOf("".concat(key + 1)) != -1, onChange: input_actions_1.default.changeInput }),
                    react_1.default.createElement("span", { className: "input-checkbox__text" }, label))))); });
        var data = form_store_1.default.getState().data;
        var is_shown = data.is_complications_before_option.indexOf("8") > -1;
        return (react_1.default.createElement("div", { className: "input-list__child" },
            errorElem,
            react_1.default.createElement("p", { className: "input-list__title" }, "\uFF1C\u8907\u6570\u9078\u629E\u53EF\uFF1E"),
            react_1.default.createElement("ul", { className: "input-list input-list--vertical" },
                form_elems,
                is_shown ? (react_1.default.createElement(IsComplicationsBeforeText_1.default, null)) : null)));
    };
    return IsComplicationsBeforeOption;
}(react_1.Component));
exports.default = IsComplicationsBeforeOption;
